export interface VideoLinkType {
  title: string;
  link: string;
}

export const VideoList: VideoLinkType[] = [
  {
    title: "Floristic Quality Index: A Discussion with Dr. Gerould Wilhelm",
    link: "https://www.youtube.com/watch?v=rRpV0MPa2OI",
  },
  {
    title: "Nature Speaks: Dr. Gerould Wilhelm",
    link: "https://www.youtube.com/watch?v=MuD9OHVyUHk",
  },
  {
    title: "Gerould Wilhelm-Flora of the Chicago Region Ep. #32",
    link: "https://www.youtube.com/watch?v=mfz-ejkAEf8",
  },
  {
    title: "The Coolest Native Plant Garden in the Tri-State Area",
    link: "https://www.youtube.com/watch?v=D0Kdp9wJNOQ",
  },
  {
    title: "Native Is Just a Word Episode",
    link: "https://www.youtube.com/watch?v=14IwCth8-GA",
  },
  {
    title: "Dr. Gerould “Jerry” Wilhelm Wetland Ecology Program",
    link: "https://www.youtube.com/watch?v=KwspPmnWjl8",
  },
  {
    title: "Why Don’t We Use Lichens for Wetland Delineation?",
    link: "https://www.youtube.com/watch?v=58MyuXjF2Vs",
  },
];

export default VideoList;
